import { Link } from "react-router-dom";

const aboutLinks = [
  { to: "/rankings", label: "综合榜单" },
  { to: "/guide", label: "避雷指南" },
  { to: "/about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-display text-xl text-foreground-950">
                漫界<span className="text-primary-500">指南</span>
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-6 text-foreground-600">
              专注漫画网站推荐与避雷的评测平台。我们从广告控制、加载速度、内容收录与良心程度四个维度出发，帮你筛出真正好用的良心站，让看漫画更省心、少踩坑。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {aboutLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-foreground-600 hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                hello@manjie-guide.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-question-line text-primary-500"></i>
                欢迎反馈评测建议
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} 漫界指南 · 为漫画爱好者提供客观评测参考</p>
          <div className="flex items-center gap-3 text-foreground-500">
            <i className="ri-remixicon-line text-base"></i>
            <span className="text-xs">仅作内容参考，阅读请尊重版权</span>
          </div>
        </div>
      </div>
    </footer>
  );
}